var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alitas-de-pollo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "Background",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.062026978 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3507 12.3595C26.1868 10.8341 25.2411 9.57669 23.821 8.99612C22.4008 8.41554 20.8452 8.65032 19.6597 9.62412L14.7511 13.656L15.088 7.9957C15.2129 5.89821 14.4881 3.90083 13.0471 2.37154C11.6061 0.842195 9.65531 0 7.5541 0C6.28746 0 5.08852 0.298695 3.99051 0.88776C2.96096 1.44008 2.05836 2.24186 1.38024 3.20623C0.702129 4.17061 0.2531 5.29129 0.0816274 6.44697C-0.101182 7.67954 0.0234109 8.90888 0.451957 10.1008L5.85322 25.123C6.35658 26.523 7.52288 27.557 8.97309 27.889C9.2984 27.9635 9.62607 27.9999 9.95088 27.9999C11.0741 27.9999 12.1616 27.5638 12.9857 26.7559L19.5897 20.281L22.519 24.7173C23.2814 25.8722 24.5628 26.5616 25.9467 26.5616L27.876 26.5616L26.3507 12.3595ZM25.9467 24.9187C25.1164 24.9187 24.3476 24.5051 23.89 23.8122L20.7848 19.1094L21.8329 18.0819L20.6827 16.9087L11.8354 25.5828C11.1747 26.2306 10.2416 26.494 9.33975 26.2876C8.43775 26.0811 7.71237 25.438 7.39927 24.5672L1.998 9.54496C1.33867 7.71127 1.60336 5.74539 2.7242 4.1513C3.84505 2.55728 5.60546 1.64307 7.55409 1.64307C9.1979 1.64307 10.724 2.30196 11.8513 3.49833C12.9785 4.69469 13.5456 6.25723 13.4479 7.89814L12.8115 18.5897L14.4516 18.6873L14.618 15.8914L15.2226 15.3949L16.8924 17.4279L18.162 16.3851L16.4922 14.3521L17.7789 13.2951L19.2428 15.0774L20.5124 14.0346L19.0485 12.2523L20.3698 11.167L22.069 13.2357L23.3386 12.1929L21.8386 10.3667C22.2856 10.2876 22.7535 10.3347 23.1994 10.5169C24.0515 10.8653 24.6189 11.6197 24.7172 12.535L26.0471 24.9187L25.9467 24.9187Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27289 5.6228L5.91587 5.6228L5.91587 7.26579L4.27289 7.26579L4.27289 5.6228Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16532 6.49585L10.8083 6.49585L10.8083 8.13884L9.16532 8.13884L9.16532 6.49585Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56289 14.1931L10.2059 14.1931L10.2059 15.8361L8.56289 15.8361L8.56289 14.1931Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67852 10.5237L7.3215 10.5237L7.3215 12.1667L5.67852 12.1667L5.67852 10.5237Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductos);
export default __webpack_public_path__ + "static/media/productos.e31d765e7d627d64ff40a4d36a61d8ef.svg";
export { ForwardRef as ReactComponent };